export default __webpack_public_path__ + "assets/arrow-down.1805d3e4.svg";